import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Paper,
  Tabs,
  Tab
} from "@material-ui/core";
import useScreensize from "../../hooks/useScreensize";
import { grey } from "@material-ui/core/colors";
import StVorstand from "./StVorstand";
import client from "../../utils/API";
import StAktiver from "./StAktiver";

const useStyles = makeStyles(theme => ({
  headlineVorstand: {
    color: grey[500],
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 3)
  }
}));

const StAktive = () => {
  const classes = useStyles();
  const { xs, sm, md, lg, xl, current } = useScreensize();
  const [aktive, setAktive] = useState([]);
  const [visibleAktive, setVisibleAktive] = useState([]);
  const [tab, setTab] = useState(0);

  useEffect(() => {
    fetchAktive();
  }, []);

  useEffect(() => {
    const map = ["buhne", "tanz", "uniformierte_garde"];
    setVisibleAktive(
      aktive.filter(
        f =>
          f.gruppenkategorien.value.filter(g => g.codename === map[tab]).length
      )
    );
  }, [tab, aktive]);

  const fetchAktive = () => {
    client
      .items()
      .type("aktiver")
      .toObservable()
      .subscribe(response => {
        setAktive(response.items);
      });
  };

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  console.log(visibleAktive);

  return (
    <>
      <Box bgcolor="white" py={{ xs: 2, md: 4, xl: 8 }}>
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            align="center"
            className={classes.headlineVorstand}
          >
            Unsere Aktiven
          </Typography>
          <Paper square>
            <Tabs
              value={tab}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleChange}
              aria-label="disabled tabs example"
            >
              <Tab label="Bühne" />
              <Tab label="Tanz" />
              <Tab label="Uniformierte Garde" />
            </Tabs>
          </Paper>
          <Box display="flex" flexDirection="column" flexWrap="wrap" mt={2}>
            {visibleAktive.map((v, idx) => (
              <Box
                width="100%"
                flexShrink={0}
                py={{ xs: 2, sm: 2 }}
                px={{ xs: 0, sm: 4 }}
                key={idx}
              >
                <StAktiver item={v} />
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default StAktive;
